import React from "react";
import { Input, Label } from "reactstrap";
import style from "./Field.module.scss";

const Switch = ({ value, label, disabled, onChange }) => (
  <div className={style.switch}>
    <Label className={style.label}>{label}</Label>

    <Label className="switch switch-text switch-pill switch-secondary switch-lg">
      <Input
        type="checkbox"
        className="switch-input"
        checked={!!value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="switch-label" data-on="Yes" data-off="No"></span>
      <span className="switch-handle"></span>
    </Label>
  </div>
);

export default React.memo(Switch);
